var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.order && _vm.hasManufacturerRights)?_c('calc-order-manufacturer',{attrs:{"order":this.order}}):(_vm.order)?_c('calc-order-customer',{attrs:{"order":this.order}}):_c('div',[_vm._v("Lädt Bestellung....")])}
var staticRenderFns = []

export { render, staticRenderFns }